(function() {
  'use strict';
  
  var swiperInstances = new Map();
  
  function initFeaturedBlog() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initFeaturedBlog, 500);
      return;
    }
    
    var sliders = document.querySelectorAll('[data-featured-blog-slider]');
    if (!sliders.length) return;
    
    var isMobile = window.innerWidth < 990;
    
    sliders.forEach(function(slider) {
      var postLimit = parseInt(slider.getAttribute('data-post-limit')) || 2;
      var hasInstance = swiperInstances.has(slider);
      
      if (!isMobile && hasInstance) {
        var existing = swiperInstances.get(slider);
        if (existing && !existing.destroyed) {
          existing.destroy(true, true);
        }
        swiperInstances.delete(slider);
        slider.classList.remove('swiper-initialized');
        return;
      }
      
      if (isMobile && hasInstance) {
        return;
      }
      
      if (!isMobile) {
        return;
      }
      
      try {
        var swiper = new Swiper(slider, {
          slidesPerView: 1.15,
          spaceBetween: 16,
          loop: true,
          loopedSlides: postLimit,
          speed: 600,
          grabCursor: true,
          watchOverflow: true,
          pagination: {
            el: slider.querySelector('.ncg-featured-blog__pagination'),
            clickable: true,
            dynamicBullets: false,
            bulletElement: 'span'
          },
          on: {
            init: function() {
              slider.classList.add('swiper-initialized');
              this.pagination.render();
              this.pagination.update();
            }
          }
        });
        
        swiperInstances.set(slider, swiper);
        
      } catch (e) {
        console.error('Blog slider init failed:', e);
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedBlog);
  } else {
    initFeaturedBlog();
  }
  
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initFeaturedBlog, 200);
  });
})();